// src/pages/Settings.tsx
import * as React from "react";

const AddListing: React.FC = () => {
  return (
    <div>
      <h1 className="text-4xl font-bold">AddListing</h1>
      <p className="mt-4">Adjust your settings here.</p>
    </div>
  );
};

export default AddListing;
